import axios, { AxiosProgressEvent } from 'axios';
import { baseApi } from './baseApi';

interface PresignedUrlResponse {
  keyFile: string;
  fileUrl: string;
  preSignedURL: string;
}

interface PresignedUrlParams {
  fileName: string;
  fileType: string;
}

interface UploadToS3Input {
  preSignedURL: string;
  file: File;
  onUploadProgress: (progressEvent: AxiosProgressEvent) => void;
}

interface CustomError {
  status: string | number;
  error: string;
}

export const s3Api = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPresignedUrl: builder.query<PresignedUrlResponse, PresignedUrlParams>({
      query: ({ fileName, fileType }) => ({
        url: '/pre-signed-url',
        method: 'GET',
        params: { fileName, fileType },
      }),
    }),
    uploadToS3: builder.mutation<void, UploadToS3Input>({
      async queryFn({ preSignedURL, file, onUploadProgress }): Promise<{ data: void } | { error: CustomError }> {
        try {
          const response = await axios.put(preSignedURL, file, {
            headers: {
              'Content-Type': file.type,
            },
            onUploadProgress,
          });

          if (response.status !== 200) {
            return {
              error: {
                status: response.status,
                error: `Upload failed with status ${response.status}`,
              },
            };
          }

          return { data: undefined };
        } catch (e) {
          const message = e instanceof Error ? e.message : 'Unknown error';
          return {
            error: {
              status: 'NETWORK_ERROR',
              error: message,
            },
          };
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useLazyGetPresignedUrlQuery, useGetPresignedUrlQuery, useUploadToS3Mutation } = s3Api;
